import React from 'react';

import CheckBoxV2WithTitleComponent from '../checkBoxV2WithTitleComponent/checkBoxV2WithTitleComponent';
import InputTitleComponent from '../inputComponentV2/components/inputTitleComponent/inputTitleComponent';
import SubTitleComponentV2 from '../subTitleComponentV2/subTitleComponentV2';
import UpgradeComponent from '../upgradeComponent/upgradeComponent';

import './multiCheckBoxComponent.css';

// const options = [
//   {
//     key: key1,
//     label: label1,
//   },
//   {
//     key: key2,
//     label: label2,
//   },
//   ...
// ];

const MultiCheckBoxComponent = ({
  id = '',
  isDisabled = false,
  billingPlanFeature = null,
  options = [],
  pillType = null,
  subTitleTxt = '',
  selectedOptionsKeys = [],
  titleTxt = '',
  toolTipPosition = 'right',
  toolTipTxt = '',
  subToolTipTxt = '',
  subToolTipPosition = 'right',
  onCheckboxClicked = () => {},
}) => {
  return (
    <div className="et-v2-multi-checkbox-container">
      <UpgradeComponent billingPlanFeature={billingPlanFeature} />
      <InputTitleComponent
        billingPlanFeature={billingPlanFeature}
        pillType={pillType}
        titleTxt={titleTxt}
        toolTipPosition={toolTipPosition}
        toolTipTxt={toolTipTxt}
      />
      <div
        className={`et-v2-multi-checkbox-sub-title-options-wrap ${isDisabled ? 'et-v2-multi-checkbox-sub-title-options-wrap-disabled' : ''}`}>
        <div className="et-v2-multi-checkbox-sub-title-crown-wrap">
          <SubTitleComponentV2
            subTitleTxt={subTitleTxt}
            subToolTipTxt={subToolTipTxt}
            subToolTipPosition={subToolTipPosition}
          />
          {!titleTxt?.length && (
            <UpgradeComponent
              isCrown={true}
              billingPlanFeature={billingPlanFeature}
            />
          )}
        </div>
        <div className="et-v2-multi-checkbox-options-wrap">
          {options.map((option) => (
            <div
              key={option.key}
              className={
                options.length <= 3
                  ? 'et-v2-multi-checkbox-single-col-option'
                  : 'et-v2-multi-checkbox-multi-col-option'
              }>
              <CheckBoxV2WithTitleComponent
                isChecked={selectedOptionsKeys.includes(option.key)}
                isDisabled={isDisabled}
                titleTxt={option.label}
                onClick={() => {
                  onCheckboxClicked(id, option.key);
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MultiCheckBoxComponent;
